import { render, staticRenderFns } from "./HeroBubble.vue?vue&type=template&id=048d146f&scoped=true&"
import script from "./HeroBubble.vue?vue&type=script&lang=js&"
export * from "./HeroBubble.vue?vue&type=script&lang=js&"
import style0 from "./HeroBubble.vue?vue&type=style&index=0&id=048d146f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048d146f",
  null
  
)

export default component.exports